import { OverlayArrow } from "react-aria-components";
import { tooltipStyle } from "./style.js";

export const TooltipArrow = () => (
  <OverlayArrow>
    <svg viewBox="0 0 8 8" className={tooltipStyle().arrowSvg()}>
      <path d="M0 0 L4 4 L8 0" />
    </svg>
  </OverlayArrow>
);
